<div class="eventSelectionCon">
	<div class="eventSelectionPanel">
		<div class="eventSelectionPanelHeader">
			<div class="backButton">
				<mat-checkbox
					color="accent"
					class="selectAllCheckBox"
					[checked]="allEventsSelected"
					#selectAllCheckbox
					[class.shown]="enableSelection"
					(change)="selectAllEvents()"
				/>
				@if (showBackButton) {
					<button mat-icon-button color="accent" (click)="onBackClicked.emit()">
						<mat-icon fontSet="fas" fontIcon="fa-arrow-left" style="font-size: 0.8em" inline />
					</button>
				}
			</div>

			<div class="icon">
				<i class="fad fa-calendar-week"> </i>
			</div>
			@if (!hideTitle) {
				<div class="title">
					{{ T.SHARED_EVENT_SELECTION_TITLE | translate }}
				</div>
			}

			@if (hideTitle) {
				<div class="title">
					{{ T.SHARED_RECORDING_SELECTION_TITLE | translate }}
				</div>
			}

			<div class="actions">
				@if (isViewToggleVisible) {
					<sim-segmented-button [activeSegment]="defaultViewMode === RecordingArchiveViewMode.Recordings ? 1 : 0">
						<sim-button-segment
							(onClick)="setCurrentView('left')"
							[icon]="{fontSet: 'fas', fontIcon: 'fa-folder'}"
							[matTooltip]="T.SHARED_EVENT_SELECTION_EVENT_VIEW | translate"
							matTooltipClass="accent"
						/>
						<sim-button-segment
							(onClick)="setCurrentView('right')"
							[icon]="{fontSet: 'fas', fontIcon: 'fa-list'}"
							[matTooltip]="T.SHARED_EVENT_SELECTION_RECORDING_VIEW | translate"
							matTooltipClass="accent"
						/>
					</sim-segmented-button>
				}
				<button
					color="accent"
					mat-icon-button
					class="eventSelectionFilterBtn"
					(click)="openFilterDialog()"
					[matBadge]="1"
					matBadgeColor="warn"
					[matBadgeHidden]="!hasFilterOptions()"
					matTooltip="{{ T.SHARED_EVENT_SELECTION_SORT_FILTER_EVENT | translate }}"
					matTooltipClass="accent"
				>
					<mat-icon fontSet="fas" fontIcon="fa-filter" style="font-size: 0.8em" inline />
				</button>

				@if (showSelectAllButton) {
					<button
						mat-icon-button
						color="accent"
						(click)="enableSelectionClicked(); selectionEnabled.emit(enableSelection)"
						matTooltip="{{ T.SHARED_EVENT_SELECTION_SORT_SELECT | translate }}"
						matTooltipClass="accent"
					>
						<mat-icon> select_all </mat-icon>
					</button>
				}

				<button
					[color]="'accent'"
					mat-icon-button
					class="eventSelectionFilterBtn"
					(click)="toggleFilterField()"
					matTooltip="{{ T.SHARED_EVENT_SELECTION_SORT_SEARCH_EVENT | translate }}"
					matTooltipClass="accent"
				>
					<mat-icon fontSet="fas" fontIcon="fa-search" style="font-size: 0.9em" inline />
				</button>

				<mat-form-field class="filterSearchField" [class.closed]="filterSearchFieldClosed" appearance="fill" color="accent">
					<mat-label>{{ T.SHARED_EVENT_SELECTION_SORT_SEARCH_EVENT | translate }}</mat-label>
					<input matInput [(ngModel)]="searchValue" (ngModelChange)="shouldRefreshData.next()" />
					@if (searchValue) {
						<button matSuffix mat-icon-button aria-label="Clear" (click)="searchValue = ''; shouldRefreshData.next()">
							<mat-icon fontSet="fas" fontIcon="fa-times" style="font-size: 1em" inline />
						</button>
					}
				</mat-form-field>
			</div>
		</div>

		<div class="eventSelectionPanelContent" (scroll)="listScrolled($event)">
			<sim-component-loading-container
				[isLoading]="loadingEvents"
				[loadingIcon]="'fad fa-list'"
				[loadingMessage]="T.GLOBAL_TEXT_LOADING | translate"
			/>

			@if (!loadingEvents) {
				<!--------------------------------------------------------->
				<!-- LEFT PANE                                           -->
				<!--------------------------------------------------------->
				@if (currentView === "left" && !loadingEvents) {
					<ng-container leftPane>
						@for (event of events; track TrackByMethods.trackById(indexEvent, event); let indexEvent = $index) {
							<div class="events">
								<sim-event-container
									[showJoinStartActions]="showJoinStartActions"
									[showOnlyRecordedScenarios]="showOnlyRecordedScenarios"
									[eventActions]="eventActions"
									[enableSelection]="enableSelection"
									[recordingSelectable]="recordingSelectable"
									[event]="event"
									[includeEmptyTrainingSessions]="includeEmptyTrainingSessions"
									[defaultOpen]="indexEvent === 0"
									[selectEventString]="selectEventString"
									(eventSelected)="toggleEventSelected(event)"
									(eventOpened)="openEvent(event)"
									(selectRecording)="selectRecordingById($event)"
									(deleteEventEmitter)="deleteEvent($event)"
									[recordingOrder]="isArchive ? 'asc' : 'desc'"
									[showExports]="showExports"
									[isArchive]="isArchive"
									[isExamSchedule]="isExamSchedule"
								/>
							</div>
						}
						@if (events?.length === 0 && !loadingEvents) {
							<div class="noEventsForFilterOptionsContainer">
								<div class="mat-h2">
									{{ T.SHARED_EVENT_SELECTION_SORT_NO_EVENT_FIND | translate }}
								</div>
								<div class="icon">
									<i class="fad fa-telescope fa-5x"></i>
								</div>
							</div>
						}
					</ng-container>
				}
				<!--------------------------------------------------------->
				<!-- RIGHT PANE                                          -->
				<!--------------------------------------------------------->
				@if (currentView === "right" && !loadingEvents) {
					<ng-container rightPane>
						<div class="allRecordingsContainer h-100">
							@if (
								syncRecordingsView
									? trainingSessionArchiveViewsSync?.length === 0 && !loadingEvents
									: trainingSessionArchiveViews?.length === 0 && !loadingEvents
							) {
								<div class="noEventsForFilterOptionsContainer">
									<div class="mat-h2">
										{{ T.NO_RECORDINGS_FOUND | translate }}
									</div>
									<div class="icon">
										<i class="fad fa-telescope fa-5x"></i>
									</div>
								</div>
							}
							@if (!syncRecordingsView) {
								@for (trainingSession of trainingSessionArchiveViews; track trainingSession) {
									<div class="trainingSessionCon" [class.displayConMultipleSR]="trainingSession.recordings?.length > 1">
										<ng-container
											[ngTemplateOutlet]="trainingSessionCon"
											[ngTemplateOutletContext]="{
												$implicit: {
													trainingSession: trainingSession,
													isSyncView: false,
												},
											}"
										/>
									</div>
								}
							}
							@if (syncRecordingsView) {
								@for (trainingSession of trainingSessionArchiveViewsSync; track trainingSession) {
									<div class="trainingSessionCon" [class.displayConMultipleSR]="trainingSession.recordings?.length > 1">
										<ng-container
											[ngTemplateOutlet]="trainingSessionCon"
											[ngTemplateOutletContext]="{
												$implicit: {
													trainingSession: trainingSession,
													isSyncView: true,
												},
											}"
										/>
									</div>
								}
							}
						</div>
					</ng-container>
				}
			}
		</div>

		<div class="numberOfEvent">
			@if (
				(currentView === "left" && !loadingEvents && events?.length > 0) ||
				(currentView === "right" && !loadingEvents && trainingSessionArchiveViews?.length > 0)
			) {
				<div style="margin-right: 10px">
					<i class="fad fa-cubes"></i>
				</div>
			}
			@if (currentView === "left" && !loadingEvents && events?.length > 0) {
				<div>
					{{ T.NUMBER_OF_EVENTS | translate }}
					<strong>{{ totalEventCount }}</strong>
				</div>
			}
			@if (currentView === "right" && !loadingEvents && trainingSessionArchiveViews?.length > 0) {
				<div>
					{{ T.NUMBER_OF_RECORDINGS | translate }}
					<strong>{{ totalRecordingCount }}</strong>
				</div>
			}
		</div>
	</div>

	@if (enableSelection && (isEventSelected() || isRecordingSelected() || isSyncRecordingSelected())) {
		<div class="selectionActions" [@zoomInOnEnter] [@zoomOutOnLeave]>
			<div class="descriptionForBulkOperationContainer">
				<mat-icon class="descriptionIcon" fontSet="fad" fontIcon="fa-tasks" inline />
				{{ T.SHARED_BASIC_ADMINISTRATION_TABLE_CHECKED_ITEM | translate }}
			</div>
			<div class="bulkActionSelect">
				<mat-form-field color="accent">
					<mat-label>{{ T.SHARED_BASIC_ADMINISTRATION_TABLE_BULK_ACTION | translate }}</mat-label>
					<mat-select [(ngModel)]="selectedBulkAction">
						@for (bulkAction of bulkActions; track bulkAction) {
							@if (isBulkActionVisible(bulkAction)) {
								<mat-option [value]="bulkAction">
									{{ bulkAction.displayNameTranslationKey }}
								</mat-option>
							}
						}
						<mat-option [value]="undefined">{{ T.MAT_OPTION_NONE_OPTION | translate }}</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<button mat-raised-button color="accent" [disabled]="!selectedBulkAction?.value" (click)="executeBulkAction()">
				{{ T.BUTTON_OK | translate }}
			</button>
		</div>
	}
</div>

<ng-template #trainingSessionCon let-options [ngAs]="TrainingSessionCon">
	@if (options.trainingSession.recordings?.length > 1) {
		<div class="trainingSessionEventNameHeader">
			<div class="icon">
				<i class="fad fa-folder-open"></i>
			</div>
			<div class="eventName">{{ options.trainingSession.eventName }}</div>
		</div>
	}
	@for (scenarioRecording of options.trainingSession.recordings; track scenarioRecording; let recordingIndex = $index) {
		<div
			class="recordingCon"
			[class.insideTSCon]="options.trainingSession.recordings?.length > 1"
			appStopPropagation
			(click)="selectRecordingById(scenarioRecording.scenarioRecordingId, $event)"
			matRipple
			[matRippleCentered]="true"
		>
			<div>
				<div class="upper">
					<div class="selectionBox" [class.visible]="enableSelection">
						<mat-checkbox
							appStopPropagation
							[disabled]="syncRecordingsView ? $any(scenarioRecording).syncStatus !== SyncStatus.Missing : false"
							#eventCheckbox
							[(ngModel)]="scenarioRecording.isSelected"
							color="accent"
						/>
					</div>
					<div class="icon">
						<i class="fad fa-photo-video"></i>
					</div>
					<div class="descriptionCon">
						<div class="date">
							{{ scenarioRecording.start | date: (T.DATE_FORMAT_LONG_DAY | translate) :'': translate.currentLang }}
							|
							{{ scenarioRecording.start | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang }}
							-
							{{ scenarioRecording.end | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang }}
							|
							<span class="duration">{{ scenarioRecording.recordingTimeMs | minsec }}</span>
						</div>
						<div class="scenario">
							<div class="scenarioText">
								{{ T.EVENT_RECORDING_CON_SCENARIO_TXT | translate }}
							</div>
							<a class="clickable" appStopPropagation (click)="openScenarioInformationDialog(scenarioRecording.scenario)">
								{{ scenarioRecording.scenario?.name || (T.GLOBAL_TXT_LOADING_WITH_DOTS | translate) }}</a
							>
						</div>
						<div class="event">
							<div class="eventText">
								{{ T.EVENT_RECORDING_CON_EVENT_TXT | translate }}
							</div>
							<div class="eventNameVal">
								{{ scenarioRecording?.eventName || (T.GLOBAL_TXT_LOADING_WITH_DOTS | translate) }}
							</div>
						</div>
						@if (scenarioRecording?.eventDescription) {
							<div class="eventDescription">
								<div class="eventDescriptionText">{{ T.SCENARIO_EDITOR_LIST_DESCRIPTION | translate }}:</div>
								<div class="eventDescriptionVal">
									{{ scenarioRecording?.eventDescription || (T.GLOBAL_TXT_LOADING_WITH_DOTS | translate) }}
								</div>
							</div>
						}
						<div class="session">
							<!--TrainingSession Data-->
							<!--<p> Ready for Archive : {{scenarioRecording.isReadyForArchive}}</p>-->
						</div>
						@if (scenarioRecording.tagIds.length > 0) {
							<div class="event">
								<div class="eventText">{{ T.GLOBAL_TEXT_TAGS_WITH_COLON | translate }}</div>
								<sim-app-tags-chip-view
									[tagIds]="scenarioRecording.tagIds"
									[tagType]="TagType.Recording"
									[allTags]="allTags"
								/>
							</div>
						}
					</div>
					<div class="playBtn" appStopPropagation>
						@if (!options.isSyncView) {
							<sim-button
								color="accent"
								[icon]="{
									fontSet: 'fad',
									fontIcon: 'fa-play',
								}"
								appStopPropagation
								[disabled]="!scenarioRecording.isReadyForArchive"
								(onClick)="selectRecordingById(scenarioRecording.scenarioRecordingId)"
								[matTooltip]="T.RECORDING_NOT_READY_FOR_ARCHIVE | translate"
								[matTooltipDisabled]="scenarioRecording.isReadyForArchive"
								[label]="getScenarioRecordingProgressText(scenarioRecording)"
							/>
						}
						@if (options.isSyncView) {
							@switch ($any(scenarioRecording)?.syncStatus) {
								@case (SyncStatus.Missing) {
									<sim-button
										color="accent"
										[icon]="{
											fontSet: 'fad',
											fontIcon: 'fa-sync',
										}"
										(onClick)="syncRecording(scenarioRecording)"
										[label]="T.EVENT_SELECTION_SYNC_RECORDING"
									/>
								}
								@case (SyncStatus.Queued) {
									<div class="syncStatusConWrapper">
										<i class="fad fa-spinner-third fa-spin accent"> </i>
										<div class="text">
											{{ T.EVENT_SELECTION_SYNC_QUEUED | translate }}
										</div>
									</div>
								}
								@case (SyncStatus.Running) {
									<div class="syncStatusConWrapper">
										<i class="fad fa-spinner-third fa-spin accent"> </i>
										<div class="text">
											{{ T.EVENT_SELECTION_SYNC_RUNNING | translate }}
										</div>
									</div>
								}
								@case (SyncStatus.Synced) {
									<sim-button
										color="accent"
										[icon]="{
											fontSet: 'fad',
											fontIcon: 'fa-check',
										}"
										(onClick)="openInArchive(scenarioRecording)"
										[label]="T.EVENT_SELECTION_SYNC_FINISHED"
									/>
								}
							}
						}
					</div>
				</div>
				@if (eventActions?.deleteEventBtn || eventActions?.lockEventBtn) {
					<div class="lower">
						<div class="divider">
							<mat-divider />
						</div>
						<div class="actionButtonsRecordingCon">
							@if (eventActions?.deleteEventBtn) {
								<button
									class="actionButton"
									mat-icon-button
									color="warn"
									[disabled]="scenarioRecording.lockedForDeletion"
									appStopPropagation
									(click)="deleteRecording(scenarioRecording)"
									matTooltip="{{ T.SHARED_EVENT_CONTAINER_DELETE_RECORDING | translate }}"
									matTooltipClass="warn"
								>
									<mat-icon inline fontSet="fad" fontIcon="fa-trash-alt" />
								</button>
							}
							@if (eventActions?.lockEventBtn) {
								<button
									class="actionButton"
									mat-icon-button
									color="accent"
									appStopPropagation
									(click)="toggleLockEvent(scenarioRecording)"
									[matTooltip]="
										(scenarioRecording.lockedForDeletion
											? T.SHARED_EVENT_CONTAINER_UNLOCK_RECORDING
											: T.SHARED_EVENT_CONTAINER_LOCK_RECORDING
										) | translate
									"
									matTooltipClass="accent"
								>
									<sim-animated-material-icon
										[trigger]="scenarioRecording.lockedForDeletion"
										[endIcon]="{
											fontSet: 'fad',
											fontIcon: 'fa-lock-alt',
										}"
										[startIcon]="{
											fontSet: 'fad',
											fontIcon: 'fa-lock-open-alt',
											themeColor: 'accent',
										}"
									/>
								</button>
							}
							@if (showExports) {
								<button
									class="actionButton"
									matTooltipClass="accent"
									[matTooltip]="T.TOOLTIP_EXPORT_RECORDING | translate"
									appStopPropagation
									(click)="openScenarioRecordingExportDialog(scenarioRecording)"
									mat-icon-button
									color="accent"
									[matBadge]="scenarioRecording.finishedExportsCount"
									matBadgeColor="warn"
								>
									<mat-icon fontSet="fad" fontIcon="fa-download" />
								</button>
							}
							@if (hasLicenseModule(Modules.TrainTheTrainer)) {
								<button
									class="actionButton"
									matTooltipClass="accent"
									[matTooltip]="T.RECORDINGS_FILESET_CREATION_BUTTON | translate"
									[hasPermission]="Permissions.ScenarioRecording_ConvertToFileSet"
									[matBadge]="scenarioRecording.finishedFileSetConversionsCount"
									appStopPropagation
									(click)="openScenarioRecordingTTTDialog(scenarioRecording)"
									mat-icon-button
									color="accent"
									matBadgeColor="warn"
								>
									<mat-icon fontSet="fad" fontIcon="fa-chalkboard-teacher" />
								</button>
							}
							@if (eventActions?.changeOwnerShipBtn) {
								<button
									class="actionButton"
									mat-icon-button
									color="accent"
									[disabled]="scenarioRecording.lockedForDeletion"
									appStopPropagation
									(click)="changeOwnership(scenarioRecording)"
									matTooltip="{{ T.CHANGE_OWNERSHIP | translate }}"
									matTooltipClass="accent"
								>
									<mat-icon inline fontSet="fad" fontIcon="fa-user" />
								</button>
							}
							@if (options.trainingSession.recordings?.length > 1) {
								<div class="runLabel">
									{{
										T.EVENT_SELECTION_REC_OUT_OF
											| translate
												: {
														current: recordingIndex + 1,
														total: options.trainingSession.recordings.length,
												  }
									}}
								</div>
							}
						</div>
					</div>
				}
			</div>
		</div>
	}
</ng-template>
